import React from 'react';

export const GoogleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24.588" viewBox="0 0 24 24.588">
      <defs>
        <clipPath id="v89duy4xya">
          <path style={{fill: 'none'}} d="M0 0h24v24.588H0z"/>
        </clipPath>
      </defs>
      <g style={{clipPath: 'url(#v89duy4xya)'}}>
        <path
          d="M11.32 6.652a12.184 12.184 0 0 1 5.58-5.409 11.755 11.755 0 0 1 9.617-.4 11.288 11.288 0 0 1 3.648 2.231c.2.186.134.224.021.338-1.037 1.042-2.079 2.08-3.114 3.125-.147.148-.255.14-.4.007C23.22 3.467 17.226 4.82 15.384 9.84a.552.552 0 0 1-.064.1c-1.32-.912-2.539-1.952-3.806-2.933a.432.432 0 0 1-.194-.355"
          transform="translate(-9.951)"
          style={{fill: '#e02b27'}}
        />
        <path
          d="M14.9 121.053a7.454 7.454 0 0 0 3.74 4.3 7.345 7.345 0 0 0 7.252-.37l3.969 3.073a10.427 10.427 0 0 1-6.42 2.865 12.1 12.1 0 0 1-12.209-5.984c-.15-.236-.262-.5-.392-.746l4.06-3.136"
          transform="translate(-9.531 -106.412)"
          style={{fill: '#3c983f'}}
        />
        <path
          d="m109.459 94.51-3.969-3.073a6.063 6.063 0 0 0 2.326-3.126 1.756 1.756 0 0 0 .106-.707c-.033-.063-.071-.081-.118-.013h-6.292l-.122-.108v-4.469l.125-.121h11.241l.113.117c.786 3.545-.193 8.758-3.411 11.5"
          transform="translate(-89.127 -72.868)"
          style={{fill: '#3169b1'}}
        />
        <path
          d="m5.371 62.99-4.06 3.136a12.49 12.49 0 0 1-.145-10.843 1.661 1.661 0 0 1 .2-.282.431.431 0 0 0 .194.355c1.267.981 2.487 2.021 3.806 2.935a7.3 7.3 0 0 0 0 4.7"
          transform="translate(0 -48.349)"
          style={{fill: '#feab00'}}
        />
        <path
          d="m101.515 82.89-.125.121c0-.088.04-.125.125-.121"
          transform="translate(-89.126 -72.864)"
          style={{fill: '#205faa'}}
        />
        <path
          d="m195.476 83.007-.113-.117c.085-.006.116.039.113.117"
          transform="translate(-171.734 -72.864)"
          style={{fill: '#205faa'}}
        />
        <path
          d="m101.387 120.841.122.108c-.076 0-.128-.019-.122-.108"
          transform="translate(-89.124 -106.225)"
          style={{fill: '#205faa'}}
        />
        <path
          d="M154.418 121.417c.047-.068.085-.05.118.013a.274.274 0 0 1-.118-.013"
          transform="translate(-135.741 -106.693)"
          style={{fill: '#205faa'}}
        />
      </g>
    </svg>
  );
};

export const AppleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.449"
      height="24.273"
      viewBox="0 0 20.449 24.273">
      <defs>
        <clipPath id="t9mxr6c39a">
          <path style={{fill: 'none'}} d="M0 0h20.449v24.273H0z"/>
        </clipPath>
      </defs>
      <g style={{clipPath: 'url(#t9mxr6c39a)'}}>
        <path
          d="M19.794 143.925c-.2.136-.387.26-.57.394a5.29 5.29 0 0 0-1.526 1.7 4.882 4.882 0 0 0-.571 1.819 5.937 5.937 0 0 0 .009 1.443 5.027 5.027 0 0 0 1.438 2.962 5.679 5.679 0 0 0 1.809 1.263c.02.009.039.021.066.036l-.112.318a14.019 14.019 0 0 1-2.275 4.043 8.315 8.315 0 0 1-1.185 1.279 3.459 3.459 0 0 1-1.321.714 2.8 2.8 0 0 1-1.1.071 6.832 6.832 0 0 1-1.669-.485 6.091 6.091 0 0 0-1.466-.4 4.588 4.588 0 0 0-1.05-.016 6.572 6.572 0 0 0-1.835.484 8.736 8.736 0 0 1-1.219.388 2.687 2.687 0 0 1-2.25-.443 6 6 0 0 1-1.121-1.015 15.842 15.842 0 0 1-2.209-3.214 15.67 15.67 0 0 1-1.4-4.039A12.06 12.06 0 0 1 0 148.594a8.3 8.3 0 0 1 .643-3.152 6.551 6.551 0 0 1 1.627-2.308 6.037 6.037 0 0 1 2.93-1.469 6.672 6.672 0 0 1 .918-.106 4.1 4.1 0 0 1 1.111.123 12.617 12.617 0 0 1 1.6.509c.393.145.79.279 1.2.386a1.266 1.266 0 0 0 .749-.018c.525-.178 1.051-.348 1.574-.531a10.555 10.555 0 0 1 1.531-.433 5.163 5.163 0 0 1 1.5-.069 7.468 7.468 0 0 1 1.733.376 5.41 5.41 0 0 1 2.626 1.945l.055.08"
          transform="translate(0 -135.748)"
          style={{fill: '#161615'}}
        />
        <path
          d="M251.548 5.735c-.006-.061-.013-.111-.017-.161a4.49 4.49 0 0 1 .4-2.184A5.669 5.669 0 0 1 255.92.1a3.442 3.442 0 0 1 .687-.1c.005.043.012.083.015.123a4.872 4.872 0 0 1-.788 3.046 6.294 6.294 0 0 1-1.9 1.934 3.993 3.993 0 0 1-1.5.6 3.362 3.362 0 0 1-.737.05c-.046 0-.091-.01-.149-.017"
          transform="translate(-241.298)"
          style={{fill: '#161615'}}
        />
      </g>
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.008"
      height="24.008"
      viewBox="0 0 24.008 24.008">
      <path
        d="M174.008 82a12 12 0 1 0-13.879 11.859v-8.384h-3.049V82h3.049v-2.641c0-3.008 1.793-4.671 4.534-4.671a18.454 18.454 0 0 1 2.687.235v2.954h-1.514a1.736 1.736 0 0 0-1.956 1.875V82h3.329l-.532 3.471h-2.8v8.388A12.006 12.006 0 0 0 174.008 82z"
        transform="translate(-150 -70)"
        style={{fill: '#3c5997', fillRule: 'evenodd'}}
      />
      <path
        d="m236.3 131.573.532-3.471H233.5v-2.252a1.735 1.735 0 0 1 1.956-1.875h1.514v-2.954a18.453 18.453 0 0 0-2.687-.235c-2.741 0-4.534 1.661-4.534 4.671v2.643H226.7v3.471h3.049v8.388a12.063 12.063 0 0 0 1.875.145 12.274 12.274 0 0 0 1.875-.145v-8.388h2.8z"
        transform="translate(-219.622 -116.098)"
        style={{fill: '#fefefe', fillRule: 'evenodd'}}
      />
    </svg>
  );
};

export const WhatsappIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 19 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1159 2.21882C11.7875 2.30097 13.3452 2.99029 14.5348 4.18078C15.8038 5.45058 16.5023 7.13848 16.5017 8.93348C16.5001 12.6376 13.4846 15.6515 9.78027 15.6515C8.38723 15.6515 7.28025 15.2235 6.56546 14.8338L3.00232 15.768L3.9559 12.2867C3.3677 11.2679 3.05819 10.1122 3.05868 8.92815C3.06017 5.22409 6.0754 2.21051 9.78017 2.21051L10.1159 2.21882ZM6.73053 13.6176L6.93456 13.7386C7.7923 14.2474 8.7755 14.5165 9.77797 14.5169H9.78024C12.8594 14.5169 15.3656 12.012 15.3668 8.9331C15.3674 7.44111 14.7868 6.03819 13.7321 4.98277C12.6773 3.92727 11.2746 3.34567 9.78247 3.34518C6.70091 3.34518 4.19475 5.84987 4.19353 8.92854C4.19311 9.98364 4.48845 11.0112 5.04768 11.9002L5.18051 12.1115L4.61614 14.172L6.73053 13.6176ZM13.1664 10.531C13.1245 10.461 13.0125 10.419 12.8446 10.3349C12.6766 10.2509 11.8509 9.84483 11.697 9.78876C11.5431 9.73282 11.4311 9.70483 11.3191 9.87282C11.2072 10.0408 10.8853 10.419 10.7873 10.531C10.6894 10.643 10.5914 10.6571 10.4235 10.573C10.2556 10.489 9.7144 10.3117 9.07292 9.73986C8.57364 9.29474 8.23658 8.74507 8.13861 8.57701C8.04067 8.40899 8.12816 8.3181 8.21223 8.23443C8.2878 8.15919 8.38021 8.03836 8.46418 7.94033C8.54816 7.84234 8.57613 7.77228 8.63213 7.66029C8.6881 7.54824 8.6601 7.45026 8.61813 7.36623C8.57613 7.28217 8.24027 6.45591 8.10032 6.1198C7.96397 5.79251 7.82551 5.83682 7.72243 5.83164C7.62458 5.8268 7.51251 5.82573 7.40057 5.82573C7.28859 5.82573 7.10665 5.86771 6.9527 6.0358C6.79876 6.20382 6.36489 6.60997 6.36489 7.43616C6.36489 8.26245 6.9667 9.06059 7.05068 9.17264C7.13465 9.28472 8.23493 10.9802 9.91966 11.7073C10.3204 11.8803 10.6332 11.9835 10.8771 12.0609C11.2794 12.1887 11.6455 12.1707 11.9349 12.1274C12.2576 12.0792 12.9286 11.7213 13.0685 11.3293C13.2084 10.9371 13.2084 10.601 13.1664 10.531Z" fill="#42C0B4"/>
    </svg>
  )
}

export const SupportIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#42C0B4" clipPath="url(#a)">
      <path d="M16 12a1 1 0 0 1-.38-.07 1.06 1.06 0 0 1-.33-.22c-.09-.092-.161-.2-.21-.32A1.09 1.09 0 0 1 15 11a1 1 0 0 1 2 0 1.09 1.09 0 0 1-.08.39c-.049.12-.12.228-.21.32A1.002 1.002 0 0 1 16 12ZM12 12a1 1 0 0 1-.38-.07 1.06 1.06 0 0 1-.33-.22c-.09-.092-.161-.2-.21-.32A1.09 1.09 0 0 1 11 11a1 1 0 0 1 2 0 1.09 1.09 0 0 1-.08.39c-.049.12-.12.228-.21.32A1.002 1.002 0 0 1 12 12ZM8 12a1 1 0 0 1-.38-.07 1.06 1.06 0 0 1-.33-.22 1 1 0 0 1-.21-.32A1.09 1.09 0 0 1 7 11a1 1 0 0 1 2 0 1.09 1.09 0 0 1-.08.39 1 1 0 0 1-.21.32A1.002 1.002 0 0 1 8 12Z" />
    </g>
    <path
      stroke="#42C0B4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 16.55v3.35a2.1 2.1 0 0 0 3.54 1.53l2.61-2.46h.87c5.52 0 10-3.8 10-8.5s-4.48-8.5-10-8.5-10 3.81-10 8.5a7.93 7.93 0 0 0 3 6.06l-.02.02Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M7 10h10v2H7z" />
      </clipPath>
    </defs>
  </svg>
  )
}

export const WizeCareLogoOtp = (props) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={244}
    height={231}
    fill="none"
    {...props}
  >
    <path
      fill="#34B6A2"
      fillRule="evenodd"
      d="M141.001 0C63.124 0 0 63.13 0 140.995 0 218.868 63.124 282 141.001 282c77.872 0 141.001-63.132 141.001-141.005C282.002 63.13 218.873 0 141.001 0Zm76.349 161.762c0 11.745-4.173 21.759-12.456 30.054-8.294 8.282-18.332 12.48-30.082 12.48-14.02 0-25.265-5.61-33.754-16.712-8.551 11.102-19.837 16.712-33.83 16.712-11.769 0-21.803-4.198-30.098-12.48-8.296-8.295-12.458-18.309-12.458-30.054V129.05c0-2.386.847-4.428 2.557-6.131 1.696-1.682 3.691-2.538 6.037-2.538h.297c2.34 0 4.323.856 6.03 2.538 1.713 1.703 2.553 3.745 2.553 6.131v32.712c0 6.918 2.437 12.811 7.373 17.699 4.862 4.918 10.761 7.342 17.709 7.342 6.905 0 12.825-2.424 17.716-7.342 4.917-4.888 7.364-10.781 7.364-17.699v-58.309c0-2.403.847-4.428 2.544-6.113 1.69-1.721 3.738-2.569 6.101-2.569h.215c2.38 0 4.379.848 6.028 2.569 1.692 1.685 2.517 3.71 2.517 6.113v58.309c0 6.918 2.456 12.811 7.367 17.699 4.935 4.918 10.83 7.342 17.732 7.342 6.976 0 12.948-2.424 17.831-7.342 4.911-4.888 7.363-10.781 7.363-17.699v-84.2c0-2.407.836-4.441 2.534-6.147 1.63-1.697 3.638-2.552 6.038-2.552h.203c2.399 0 4.396.855 6.102 2.552 1.639 1.706 2.467 3.74 2.467 6.147v84.2Z"
      clipRule="evenodd"
    />
  </svg>
  )
}


export const ClalitProviderIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="85 0 40 34"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#00AEEF"
        d="m102.368 1.573-7.551 6.26a1.734 1.734 0 0 1-1.16.438h-5.038a.883.883 0 0 0-.836.669l-.992 4.66a.52.52 0 0 0 .113.459c.11.127.273.195.44.184h8.995a2.311 2.311 0 0 0 1.576-.538l5.431-4.486a.852.852 0 0 1 .598-.214.89.89 0 0 1 .66.284l3.59 4.232a2.155 2.155 0 0 0 1.735.735h8.051a.847.847 0 0 0 .797-.656l1.005-4.682a.507.507 0 0 0-.096-.457.52.52 0 0 0-.43-.19h-6.787a.814.814 0 0 1-.66-.306l-5.382-6.34a2.393 2.393 0 0 0-1.925-.895c-.8.005-1.566.318-2.134.874"
      />
      <path
        fill="#00A651"
        d="M86.14 19.777a.847.847 0 0 0-.796.673l-1.005 4.682a.51.51 0 0 0 .094.457.525.525 0 0 0 .428.195h6.79a.805.805 0 0 1 .66.31l5.387 6.34a2.39 2.39 0 0 0 1.921.873 3.118 3.118 0 0 0 2.138-.874l7.525-6.26a1.748 1.748 0 0 1 1.16-.437h5.046a.914.914 0 0 0 .837-.665l1.005-4.62a.52.52 0 0 0-.112-.458.534.534 0 0 0-.437-.185h-8.995a2.29 2.29 0 0 0-1.593.516l-5.423 4.498a.834.834 0 0 1-.593.214.89.89 0 0 1-.655-.284l-3.594-4.232a2.146 2.146 0 0 0-1.736-.73l-8.051-.013Z"
      />
    </g>
  </svg>
  )
}

export const LeumitProviderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={25}
      viewBox="0 0 64 64"
      {...props}
    >
      <path
        fill="#F1138D"
        d="M31 0c4.337 1.037 6.24 3.093 8.813 6.625l1.832 2.477L43 11c2.881-1.135 5.69-2.32 8.5-3.625C54.793 6.081 56.566 5.871 60 6c5.159 9.373 5.508 19.935 3.305 30.258C59.786 46.872 52.25 55.61 42.703 61.39 37.937 63.724 33.298 65.199 28 64 16.753 59.917 8.925 53.27 3.5 42.625-.811 33.356-1.725 22.576.895 12.59 1.823 10.31 2.793 8.145 4 6c5.148.429 8.778 1.664 13.3 4.16 1.683.988 1.683.988 3.7.84 1.707-1.952 1.707-1.952 3.438-4.375C26.568 3.726 27.97 2.019 31 0"
      ></path>
      <path
        fill="#DA619F"
        d="M4 6c6.491.423 11.335 2.911 17 6l-4 12c-1.051 12.788.796 24.124 9.219 34.098A203 203 0 0 0 32 64c-9.285-.733-16.7-5.789-22.953-12.387C.59 40.817-1.248 29.303 0 16c.944-3.6 2.177-6.76 4-10"
      ></path>
      <path
        fill="#7C0179"
        d="M31 0c4.21 1.035 6.265 3.003 8.875 6.375l1.867 2.336C43 11 43 11 43.008 13.039 41.594 15.79 39.415 17.091 37 19c-7.358 10.321-10.063 19.424-9 32 .8 4.066 1.817 8.03 3 12-8.74-6.65-13.173-14.123-15-25-1.286-12.157 1.238-22.37 8.625-32.187C26.692 3.292 28.247 1.834 31 0"
      ></path>
    </svg>
  )
}

export const SsoIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#003057"
      d="M12.5 7V5c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8Zm-6 12h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V9h2v2Zm0-4h-2V5h2v2Zm4 12h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V9h2v2Zm0-4h-2V5h2v2Zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1Zm-1-8h-2v2h2v-2Zm0 4h-2v2h2v-2Z"
    />
  </svg>
  );
};

export const ArrowDownIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
    <path d="M7.26667 7.7418L10.5 10.9751L13.7333 7.7418C14.0583 7.4168 14.5833 7.4168 14.9083 7.7418C15.2333 8.0668 15.2333 8.5918 14.9083 8.9168L11.0833 12.7418C10.7583 13.0668 10.2333 13.0668 9.90833 12.7418L6.08333 8.9168C5.75833 8.5918 5.75833 8.0668 6.08333 7.7418C6.40833 7.42513 6.94167 7.4168 7.26667 7.7418V7.7418Z" fill="#003057"/>
    </svg>
  );
};

export const USFlagIcon = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_2257_1013)">
    <path d="M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20Z" fill="#F0F0F0"/>
    <path d="M10.0649 9.99982H20.4997C20.4997 9.09724 20.3794 8.22287 20.1552 7.39111H10.0649V9.99982Z" fill="#D80027"/>
    <path d="M10.0649 4.78205H19.032C18.4198 3.78314 17.6371 2.90021 16.7246 2.17334H10.0649V4.78205Z" fill="#D80027"/>
    <path d="M10.4998 20.0001C12.8532 20.0001 15.0164 19.1866 16.7246 17.8262H4.27492C5.98312 19.1866 8.14628 20.0001 10.4998 20.0001Z" fill="#D80027"/>
    <path d="M1.96754 15.2166H19.0321C19.5235 14.4147 19.9047 13.5381 20.1553 12.6079H0.844299C1.09496 13.5381 1.4761 14.4147 1.96754 15.2166Z" fill="#D80027"/>
    <path d="M5.13219 1.56164H6.04348L5.19582 2.17746L5.51961 3.17391L4.67199 2.55809L3.82437 3.17391L4.10406 2.31309C3.35773 2.93477 2.70359 3.66313 2.16453 4.47469H2.45652L1.91695 4.86668C1.83289 5.00691 1.75227 5.14937 1.675 5.29395L1.93266 6.08695L1.45195 5.7377C1.33246 5.99086 1.22316 6.24973 1.12492 6.51398L1.40879 7.38773H2.45652L1.60887 8.00355L1.93266 9L1.08504 8.38418L0.577305 8.75309C0.526484 9.1616 0.5 9.5777 0.5 10H10.5C10.5 4.47719 10.5 3.82609 10.5 0C8.52453 0 6.68301 0.573047 5.13219 1.56164ZM5.51961 9L4.67199 8.38418L3.82437 9L4.14816 8.00355L3.30051 7.38773H4.34824L4.67199 6.39129L4.99574 7.38773H6.04348L5.19582 8.00355L5.51961 9ZM5.19582 5.09051L5.51961 6.08695L4.67199 5.47113L3.82437 6.08695L4.14816 5.09051L3.30051 4.47469H4.34824L4.67199 3.47824L4.99574 4.47469H6.04348L5.19582 5.09051ZM9.10656 9L8.25895 8.38418L7.41133 9L7.73512 8.00355L6.88746 7.38773H7.9352L8.25895 6.39129L8.5827 7.38773H9.63043L8.78277 8.00355L9.10656 9ZM8.78277 5.09051L9.10656 6.08695L8.25895 5.47113L7.41133 6.08695L7.73512 5.09051L6.88746 4.47469H7.9352L8.25895 3.47824L8.5827 4.47469H9.63043L8.78277 5.09051ZM8.78277 2.17746L9.10656 3.17391L8.25895 2.55809L7.41133 3.17391L7.73512 2.17746L6.88746 1.56164H7.9352L8.25895 0.565195L8.5827 1.56164H9.63043L8.78277 2.17746Z" fill="#0052B4"/>
    </g>
    <defs>
    <clipPath id="clip0_2257_1013">
    <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>
  );
};
export const GlobalFlagIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 471.461 471.461"
      fill="#000000"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <path d="M235.735,471.456c129.984,0,235.726-105.752,235.726-235.726c0-129.973-105.752-235.725-235.726-235.725 
          C105.761,0.005,0,105.747,0,235.73C0,365.714,105.751,471.456,235.735,471.456z 
          M421.152,193.942c-19.662-11.465-14.746,1.635-14.746,1.635s0,0,13.109,11.465c13.111,11.466,22.941,16.39,18.025,32.445 
          c-4.914,16.057-13.109,1.961-29.49,15.072c-16.391,13.109,19.66,16.389,21.295,36.049c1.637,19.662-19.66,9.832-29.49,29.492 
          s-1.635,40.965-6.551,58.99c-4.914,18.025-45.881,42.602-60.76,50.797s-4.781-18.025,0-36.051s-11.34-37.686-11.34-70.457 
          s-9.83-22.939-39.322-22.939c-29.49,0-42.6-16.391-45.88-47.518c-3.28-31.135,24.576-62.261,37.685-72.091 
          c13.111-9.831,31.137-19.661,49.152-9.831c18.025,9.831,24.576,19.661,44.236,19.661s19.66-6.55,31.135-14.746 
          c11.465-8.195-16.391-18.025-32.77-16.313c-16.381,1.712-13.111-9.897-34.406-18.092c-21.297-8.195-29.492,8.195-36.051,11.465 
          c-6.551,3.28-29.49,13.11-31.787,0c-2.285-13.11,12.117-14.745,26.871-14.745c14.746,0,1.635-11.465-3.279-19.661 
          c-4.916-8.195-14.746-8.195-21.85-14.592c-7.096-6.397,8.74-18.178,25.119-14.267c16.381,3.911,9.83,15.75,27.855,14.114 
          s0-18.025,0-33.899c0-15.874,19.662-15.262,32.771-21.592c13.109-6.331,29.49,27.635,40.965,41.377 
          c3.797,4.552,9.219,2.534,14.766-2.113c28.984,33.354,48.367,75.228,53.836,121.338 
          C436.824,217.695,438.346,203.973,421.152,193.942z 
          M235.735,9.567c9.046,0,17.949,0.593,26.718,1.635 
          c-3.213,8.941-8.436,15.616-8.436,15.616s-6.549,21.295-21.304,22.94c-14.755,1.645-32.771,0-40.966,13.11 
          c-8.195,13.11-6.55,36.051-19.66,22.94c-13.11-13.11-1.635-14.114-14.746-27.54c-13.11-13.425-16.39-13.425-22.94-13.425 
          c-1.932,0-4.122-3.337-5.862-8.214C160.468,19.378,196.968,9.567,235.735,9.567z 
          M98.991,55.735c-0.364,2.362,1.711,5.795,11.781,9.993 
          c19.661,8.195,24.193,24.423,15.138,23.782c-9.056-0.641-45.853,4.379-12.011,14.209 
          c33.851,9.831,31.059,21.353,16.008,26.268c-15.052,4.916-11.829-16.361-15.109,4.944 
          c-3.28,21.305-6.579,19.67-17.231,22.95c-10.653,3.28-30.323,19.67-30.323,31.136c0,11.465-6.56,17.882,6.55,27.712 
          c13.11,9.83-4.103,27.809-10.299,14.708c-7.44-15.721-12.642-24.395-20.837-26.039c-8.195-1.635-18.752,11.465,0,24.575 
          s19.661,21.305,19.661,31.135s13.569,9.83,23.992,8.195c10.414-1.635,31.805,26.221,39.14,37.686 
          c7.325,11.467,20.435,22.941,38.46,27.855c18.025,4.916,24.576,16.391,14.746,24.576c-9.83,8.195-11.465,27.855-22.94,32.771 
          c-11.475,4.914-13.11,19.66-19.661,26.221c-3.844,3.844-7.573,8.834-10.691,14.602 
          c-9.782-5.498-19.115-11.705-27.941-18.543c-0.268-1.453-0.564-2.926-0.698-4.254 
          c-1.635-16.391-3.28-36.051-13.11-44.236c-9.831-8.195-16.39-19.66-19.661-32.771 
          c-3.271-13.109,4.915-32.77-1.635-45.881c-6.55-13.109-6.55-0.822-19.661-19.248 
          c-13.11-18.428-13.11-18.438-21.305-33.183c-4.379-7.889-7.334-20.463-9.151-33.708 
          C21.296,142.084,53.387,90.466,98.991,55.735z" />
      </g>
    </svg>
  );
};

export const BackIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#42C0B4"
      d="M15 8.25H5.872l4.193-4.192L9 3 3 9l6 6 1.057-1.057L5.872 9.75H15v-1.5Z"
    />
  </svg>
  );
};

export const LogoutIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      {/* Door */}
      <path
        fill="#42C0B4"
        d="M3 3h6v1.5H4.5v9H9V15H3V3Z"
      />
      
      {/* Arrow */}
      <path
        fill="#42C0B4"
        d="M13.5 5.25 12.443 6.307 14.886 8.75H7.5v1.5h7.386l-2.443 2.443L13.5 13.75 18 9.25l-4.5-4Z"
      />
    </svg>
  );
};

export const OTPIcon = () => {
  let fillNone = {
    fill: 'none',
  }
  let fillGray = {
    fill: '#161615'
  }
  let style = {
    stroke: '#161615', strokeMiterlimit: '10', strokeWidth: '.25px', fill: 'none'
  }
  let fillWhite = {
    fill: '#fff'
  }
  return (
    <svg width="32.17" height="20.084" viewBox="0 0 32.17 20.084">
      <defs>
        <clipPath id="3tg85lupwa">
          <path style={fillNone} d="M0 0h16.324v11.025H0z"/>
        </clipPath>
        <clipPath id="99le42oqob">
          <path style={fillNone} d="M0 0h11.638v20.084H0z"/>
        </clipPath>
      </defs>
      <g>
        <g>
          <g transform="translate(15.845 4.986)" style={{
            clipPath: 'url(#3tg85lupwa)'
          }}>
            <path
              d="M8.932 1.007h6.548a1.309 1.309 0 0 1 1.334.974 1.3 1.3 0 0 1 .043.366v7.878a1.3 1.3 0 0 1-.982 1.281 2.212 2.212 0 0 1-.441.053H2.429a1.31 1.31 0 0 1-1.379-.986 1.552 1.552 0 0 1-.045-.44c0-2.57.009-5.14-.008-7.71A1.383 1.383 0 0 1 2.438 1c2.164.019 4.329.006 6.493.006M1.685 2.138a2.347 2.347 0 0 0-.028.239v7.8a.663.663 0 0 0 .723.715h13.1a.665.665 0 0 0 .73-.726V2.382a1.885 1.885 0 0 0-.031-.235l-.165.139-6.09 5.467a1.346 1.346 0 0 1-1.978 0Q5.627 5.68 3.311 3.6L1.685 2.138m14-.454H2.223l-.028.038c.048.036.1.067.144.107l6.077 5.452a.664.664 0 0 0 1.032 0l5.733-5.141c.159-.143.317-.287.5-.456"
              transform="translate(-.768 -.769)" style={fillGray}/>
            <path
              d="M6.349 11.026H1.664a1.549 1.549 0 0 1-1.6-1.152 1.754 1.754 0 0 1-.054-.506V6.819c0-1.691 0-3.44-.008-5.16A1.639 1.639 0 0 1 .47.474 1.667 1.667 0 0 1 1.672 0C3.22.014 4.794.011 6.317.009h8.395a1.542 1.542 0 0 1 1.609 1.572v7.877a1.535 1.535 0 0 1-1.167 1.509 2.393 2.393 0 0 1-.488.057h-8.32M1.655.464A1.2 1.2 0 0 0 .8.8a1.178 1.178 0 0 0-.334.852c.011 1.721.01 3.471.008 5.163v2.549a1.355 1.355 0 0 0 .035.373 1.079 1.079 0 0 0 1.157.821h13a1.941 1.941 0 0 0 .394-.048 1.063 1.063 0 0 0 .8-1.054V1.578a1.1 1.1 0 0 0-.033-.3 1.137 1.137 0 0 0-.35-.557l-.587.533c-.111.1-.215.2-.319.289L8.836 6.686a.893.893 0 0 1-1.342 0L1.416 1.234a.753.753 0 0 0-.076-.056L1.1 1l.238-.32h14.086a1.177 1.177 0 0 0-.712-.213H6.318c-1.524 0-3.1.006-4.65-.009h-.013m.36.684L7.8 6.34a.444.444 0 0 0 .722 0l5.736-5.14.057-.051zm6.146 9.211H1.613a.892.892 0 0 1-.955-.946v-7.8a1.228 1.228 0 0 1 .017-.172c0-.027.009-.058.013-.094L.74.9l3.371 3.025 3.223 2.892A1.121 1.121 0 0 0 9 6.812q2.053-1.841 4.1-3.684l1.983-1.78c.032-.029.065-.056.107-.09l.386-.322.058.415c0 .03.009.057.013.082a1.074 1.074 0 0 1 .02.185v7.785a.891.891 0 0 1-.962.957H8.162M1.121 1.865v7.547a.436.436 0 0 0 .491.483h13.1a.436.436 0 0 0 .5-.494V1.864l-1.796 1.609-4.105 3.685a1.583 1.583 0 0 1-2.288.005Q5.411 5.718 3.8 4.27z"
              style={fillGray}/>
          </g>
        </g>
        <g>
          <g>
            <g style={{
              clipPath: 'url(#99le42oqob)'
            }}>
              <path
                d="M11.469 10.083v8.671c0 .823-.339 1.162-1.162 1.162H1.382c-.786 0-1.134-.35-1.134-1.139V1.384C.248.6.6.249 1.385.249h8.95c.784 0 1.133.351 1.133 1.138v8.7M10.787 2.6H.942v13.338h9.845V2.6M.956 16.625a.458.458 0 0 0-.028.114v2.2c0 .256.161.31.379.31h9.126c.285 0 .366-.082.368-.37V16.63H.956m9.835-14.724V1.38c0-.415-.047-.463-.457-.463H1.392c-.077 0-.172-.024-.229.011-.093.056-.219.146-.23.234a5.9 5.9 0 0 0-.011.743h9.869"
                transform="translate(-.039 -.04)" style={fillGray}/>
              <path
                d="M11.469 10.083v8.671c0 .823-.339 1.162-1.162 1.162H1.382c-.786 0-1.134-.35-1.134-1.139V1.384C.248.6.6.249 1.385.249h8.95c.784 0 1.133.351 1.133 1.138l.001 8.696zM10.787 2.6H.942v13.338h9.845zM.956 16.625a.458.458 0 0 0-.028.114v2.2c0 .256.161.31.379.31h9.126c.285 0 .366-.082.368-.37V16.63zm9.835-14.719V1.38c0-.415-.047-.463-.457-.463H1.392c-.077 0-.172-.024-.229.011-.093.056-.219.146-.23.234a5.9 5.9 0 0 0-.011.743z"
                transform="translate(-.039 -.04)"
                style={style}/>
              <path
                d="M9.012 20H1.363a1.081 1.081 0 0 1-1.237-1.244V1.365A1.08 1.08 0 0 1 1.366.126h8.95a1.081 1.081 0 0 1 1.237 1.242v17.366c0 .875-.39 1.265-1.266 1.265zM5.841.333H1.366C.642.333.333.642.333 1.365v17.391c0 .735.3 1.035 1.03 1.035h8.924c.762 0 1.059-.3 1.059-1.058V1.368c0-.735-.3-1.035-1.03-1.035H5.841m-4.56 19c-.124 0-.477-.005-.477-.413v-2.2a.346.346 0 0 1 .023-.112l.008-.027.02-.078h10.03v2.354c0 .356-.13.474-.471.474H1.281zm-.267-2.623v2.21c0 .14.041.206.273.206H10.413c.228 0 .262-.034.264-.267V16.71zm9.857-.688H.819V3.075h10.052zm-9.845-.207h9.638V3.3H1.027zm9.85-13.824H.8v-.31a3.709 3.709 0 0 1 .011-.551c.013-.1.1-.2.279-.309a.36.36 0 0 1 .222-.03h9.003c.466 0 .56.1.561.566zm-9.87-.208h9.662v-.422c0-.358 0-.358-.353-.358H1.372C1.346 1 1.321 1 1.3 1a.307.307 0 0 0-.1 0c-.172.105-.181.157-.181.158A3.339 3.339 0 0 0 1 1.671v.112"
                transform="translate(-.02 -.02)" style={fillGray}/>
              <path
                d="M9.012 20H1.363a1.081 1.081 0 0 1-1.237-1.244V1.365A1.08 1.08 0 0 1 1.366.126h8.95a1.081 1.081 0 0 1 1.237 1.242v17.366c0 .875-.39 1.265-1.266 1.265zM5.841.333H1.366C.642.333.333.642.333 1.365v17.391c0 .735.3 1.035 1.03 1.035h8.924c.762 0 1.059-.3 1.059-1.058V1.368c0-.735-.3-1.035-1.03-1.035zm-4.56 19c-.124 0-.477-.005-.477-.413v-2.2a.346.346 0 0 1 .023-.112l.008-.027.02-.078h10.03v2.354c0 .356-.13.474-.471.474H1.281zm-.267-2.623v2.21c0 .14.041.206.273.206H10.413c.228 0 .262-.034.264-.267V16.71zm9.857-.688H.819V3.075h10.052zm-9.845-.207h9.638V3.3H1.027zm9.85-13.824H.8v-.31a3.709 3.709 0 0 1 .011-.551c.013-.1.1-.2.279-.309a.36.36 0 0 1 .222-.03h9.003c.466 0 .56.1.561.566zm-9.87-.208h9.662v-.422c0-.358 0-.358-.353-.358H1.372C1.346 1 1.321 1 1.3 1a.307.307 0 0 0-.1 0c-.172.105-.181.157-.181.158A3.339 3.339 0 0 0 1 1.671z"
                transform="translate(-.02 -.02)"
                style={style}/>
              <path
                d="M1.084 19.718h9.843v2.249c0 .289-.082.371-.368.371H1.433c-.218 0-.379-.054-.379-.31v-2.2a.5.5 0 0 1 .029-.114"
                transform="translate(-.167 -3.132)" style={fillWhite}/>
              <path
                d="M1.084 19.718h9.843v2.249c0 .289-.082.371-.368.371H1.433c-.218 0-.379-.054-.379-.31v-2.2a.5.5 0 0 1 .03-.11z"
                transform="translate(-.167 -3.132)"
                style={style}/>
              <path
                d="M1.393 22.508c-.484 0-.585-.281-.585-.517v-2.2a.449.449 0 0 1 .028-.145l.007-.02.04-.156H11.1v2.458c0 .4-.174.577-.575.577H1.394zm-.169-2.622v2.1c0 .082 0 .1.17.1H10.52a.33.33 0 0 0 .146-.018.433.433 0 0 0 .016-.147v-2.04z"
                transform="translate(-.128 -3.093)" style={fillGray}/>
              <path
                d="M1.393 22.508c-.484 0-.585-.281-.585-.517v-2.2a.449.449 0 0 1 .028-.145l.007-.02.04-.156H11.1v2.458c0 .4-.174.577-.575.577H1.394zm-.169-2.622v2.1c0 .082 0 .1.17.1H10.52a.33.33 0 0 0 .146-.018.433.433 0 0 0 .016-.147v-2.04z"
                transform="translate(-.128 -3.093)"
                style={style}/>
              <path
                d="M10.917 3.444H1.048c0-.58-.02-1.16.011-1.724a1.455 1.455 0 0 1 .076-.62c.057-.082 6.344.051 9.325.052.41 0 .456.111.457 1.072v1.22"
                transform="translate(-.165 -.162)" style={fillWhite}/>
              <path
                d="M10.917 3.466H1.048c0-.58-.02-1.16.011-1.724a1.128 1.128 0 0 1 .23-.541c.057-.082 6.19-.028 9.171-.027.41 0 .456.111.457 1.072z"
                transform="translate(-.165 -.184)"
                style={style}/>
              <path
                d="M11.086 4.177H.8v-1c0-.439-.008-.892.016-1.348a1.74 1.74 0 0 1 .326-.921A.237.237 0 0 1 1.427.8c.018 0 .031 0 .052.008h8.942c.527 0 .664.331.665 1.608zm-9.872-1h9.457v-1.04c0-.5-.009-.7-.017-.784-.024-.026-.086-.052-.233-.052-2.444 0-9.205-.135-9.208-.135-.075.156.021.366.01.408-.018.5-.013 1.022-.01 1.573v.033"
                transform="translate(-.126 -.125)" style={fillGray}/>
              <path
                d="M11.086 4.177H.8v-1c0-.439-.008-.892.016-1.348a1.74 1.74 0 0 1 .326-.921A.237.237 0 0 1 1.427.8c.018 0 .031 0 .052.008h8.942c.527 0 .664.331.665 1.608zm-9.872-1h9.457v-1.04c0-.5-.009-.7-.017-.784-.024-.026-.086-.052-.233-.052-2.611 0 .263.019-9.2 0 0 0 .006.337-.005.379-.018.5 0 .915 0 1.466zm0-1.16z"
                transform="translate(-.126 -.125)"
                style={style}/>
              <path d="M7.4 21.165a.59.59 0 1 1-.59-.59.59.59 0 0 1 .59.59"
                    transform="translate(-.989 -3.269)" style={fillGray}/>
            </g>
          </g>
          <path transform="translate(.74 .464)" style={fillGray} d="M0 0h2.961v.74H0z"/>
        </g>
      </g>
    </svg>
  );
};
